<template>
  <div
    class="ll-quiz-question-show"
    :class="type"
  >
    <div class="ll-quiz-question-show__left">
      <div class="ll-quiz-question-show__left-title">
        <WsText001
          v-if="index"
          h4
          class="index"
        >
          {{ index }}.
        </WsText001>
        <WsText001
          :h4="content?false:true"
          :h5="content?true:false"
          :bold="content?true:false"
          class="ml-10"
        >
          {{ $t(title) }}
        </WsText001>
      </div>
      <WsText001
        v-if="content"
        h4
        class="mt-20 ml-10"
        style="white-space: pre-line"
      >
        {{ content }}
      </WsText001>
    </div>
    <ListCard
      v-if="type=='print'"
      is-table
      white
      no-padding
      class="pb-20 mt-0"
    >
      <ListCardItem
        v-for="(listItem,listItemIndex) in items"
        :key="listItemIndex"
        is-table
        v-bind="listItem"
        :avatar-name="listItem.name"
        :text-content="listItem.text"
        :isloading="isloading"
      />
    </ListCard>
    <div
      v-else
      class="ll-quiz-question-show__right"
    >
      <WsCol>
        <WsChip002 :color="chipColor">
          {{ $t(chipContent) }}
        </WsChip002>
        <WsInfo
          v-if="textContent"
          type="text"
          :title="textTitle"
          :value="textContent"
        />
        <LvFileList
          v-if="attaches.length>0"
          nonBorderTop
          :value="attaches"
          @go-to="$emit('go-to', $event)"
        />
      </WsCol>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlQuizQuestionShow",
  props: {
    textTitle: {
      type: String,
      default() {
        return this.$t("說明");
      },
    },
    fileTitle: {
      type: String,
      default() {
        return this.$t("附件");
      },
    },
    chipContent: {
      type: String,
      default: "",
    },
    chipColor: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    index: {
      type: String,
      default: "",
    },
    textContent: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: null,
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    popupActive: false,
  }),
  methods: {
    btnClick($event) {
      this.$emit("input", $event);
    },
    resetTextArea($event) {
      this.$emit("reset-textarea", $event);
    },
    $_popupOpen() {
      this.popupActive = true;
    },
    $_popupClose() {
      this.popupActive = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-quiz-question-show";
</style>